import React from 'react';
import { Field } from 'formik';
import { FormInput, FormControlledInput } from '../forms/elements';
import { Button } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';

var FilterAccordionInput = function FilterAccordionInput(_ref) {
  var onChange = _ref.onChange,
      resetForm = _ref.resetForm,
      label = _ref.label,
      name = _ref.name,
      controlled = _ref.controlled,
      value = _ref.value;
  var ComponentType = controlled ? FormControlledInput : FormInput;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
    name: name ? name : "searchValue",
    label: label ? label : "Search FAQ Topics",
    component: ComponentType,
    changeHandler: onChange,
    value: value,
    className: "cb-form__input--full"
  }), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-unstyled cb-form__search-button",
    onClick: function onClick() {
      onChange("");
    }
  }, /*#__PURE__*/React.createElement(FaTimes, null)));
};

export default FilterAccordionInput;